<template>
<div class="chapter">
<div class="inner_page">
<a id="Page-3"></a>
<h1 class="Chap_head_f">LAST YEARS OF THE</h1>
<h1 class="Chap_head_t">LONDON</h1>
<h1 class="Chap_head2">TITAN</h1>
<div class="img_container1y"><img alt="image" src="images/page3_1.jpg"/></div>
<div class="img_container"><img alt="image" src="images/main-1.jpg"/></div>
<p class="Chap_head">MATTHEW WHARMBY</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002_Title.vue?e34eb5a6